/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GamingXPTransactionHistoryResponsePagination
 */
export interface GamingXPTransactionHistoryResponsePagination {
    /**
     * Total number of gaming XP transactions
     * @type {number}
     * @memberof GamingXPTransactionHistoryResponsePagination
     */
    total?: number;
    /**
     * Number of transactions per page
     * @type {number}
     * @memberof GamingXPTransactionHistoryResponsePagination
     */
    limit?: number;
    /**
     * Starting offset
     * @type {number}
     * @memberof GamingXPTransactionHistoryResponsePagination
     */
    offset?: number;
    /**
     * Whether more transactions exist
     * @type {boolean}
     * @memberof GamingXPTransactionHistoryResponsePagination
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the GamingXPTransactionHistoryResponsePagination interface.
 */
export function instanceOfGamingXPTransactionHistoryResponsePagination(value: object): value is GamingXPTransactionHistoryResponsePagination {
    return true;
}

export function GamingXPTransactionHistoryResponsePaginationFromJSON(json: any): GamingXPTransactionHistoryResponsePagination {
    return GamingXPTransactionHistoryResponsePaginationFromJSONTyped(json, false);
}

export function GamingXPTransactionHistoryResponsePaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GamingXPTransactionHistoryResponsePagination {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : json['total'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function GamingXPTransactionHistoryResponsePaginationToJSON(json: any): GamingXPTransactionHistoryResponsePagination {
    return GamingXPTransactionHistoryResponsePaginationToJSONTyped(json, false);
}

export function GamingXPTransactionHistoryResponsePaginationToJSONTyped(value?: GamingXPTransactionHistoryResponsePagination | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total': value['total'],
        'limit': value['limit'],
        'offset': value['offset'],
        'hasMore': value['hasMore'],
    };
}

